function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const serialize = form => {
  const pairs = [];
  Array.prototype.forEach.call(form, element => {
    if (element.disabled || !element.name || !element.value) {
      return;
    }
    if (['checkbox', 'radio'].includes(element.type) && !element.checked) {
      return;
    }
    if (!/^(?:input|select|textarea|keygen)/i.test(element.nodeName) || /^(?:submit|button|image|reset|file)$/i.test(element.type)) {
      return;
    }
    if (element.type === 'select-multiple') {
      Array.prototype.filter.call(element.options, o => o.selected && o.value).forEach(o => {
        pairs.push([element.name, o.value]);
      });
      return;
    }
    pairs.push([element.name, element.value]);
  });
  const result = pairs.map(_ref => {
    let _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return `${encodeURIComponent(key)}=${encodeURIComponent(value.replace(/(\r)?\n/g, '\r\n')).replace(/%20/g, '+')}`;
  }).join('&');
  return result;
};
export default serialize;